import { trace } from 'owa-trace';
import { logUsage } from 'owa-analytics';
import LinkPlugin from '../../plugin/LinkPlugin';

export function stopReasonAfterGetSharingInfo(
    linkPlugin: LinkPlugin,
    originalAnchorElementId: string,
    linkIndex: number,
    anchorElement: HTMLAnchorElement
): string {
    // The following check is only needed after async call.
    if (!linkPlugin.editor) {
        // This plugin has been disposed. No need to do anything
        logUsage('ComposeEditorIsNullDuringProcessSPLinks', [linkIndex < 20 ? linkIndex : 20]);
        return 'editorDisposed';
    }

    // If linkId changes during making server call
    // user has probably changed the link. No need to continue
    if (!areIdsFromSameLink(originalAnchorElementId, anchorElement.id)) {
        trace.warn(
            `LinkId changes during server call LinkIdBefore: ${originalAnchorElementId}, LinkIdNow: ${
                anchorElement.id
            }`
        );

        return 'linkIdChanged';
    }

    // This is the scenario when user converts the anchor element to text, no need to continue
    const linksMatchingId = linkPlugin.editor.queryElements('#' + anchorElement.id);
    if (!linksMatchingId || linksMatchingId.length !== 1 || linksMatchingId[0] !== anchorElement) {
        trace.warn(
            `The result from querying the editor is not matching the original anchor element with id: ${
                anchorElement.id
            }`
        );
        return 'userCanceledOperation';
    }

    return null;
}

function areIdsFromSameLink(oldId: string, newId: string): boolean {
    return oldId === newId;
}
